import type { ExtractPropTypes } from 'vue';

const baseImageProps = {
  // input source
  src: { type: String, required: false },
  // modifiers
  format: { type: String, required: false },
  quality: { type: [Number, String], required: false },
  background: { type: String, required: false },
  fit: { type: String, required: false },
  modifiers: { type: Object, required: false },
  // options
  preset: { type: String, required: false },
  provider: { type: String, required: false },
  sizes: { type: [Object, String], required: false },
  densities: { type: String, required: false },
  preload: {
    type: [Boolean, Object],
    required: false,
  },
  // <img> attributes
  width: { type: [String, Number], required: false },
  height: { type: [String, Number], required: false },
  alt: { type: String, required: false },
  referrerpolicy: { type: String, required: false },
  usemap: { type: String, required: false },
  longdesc: { type: String, required: false },
  ismap: { type: Boolean, required: false },
  loading: {
    type: String,
    required: false,
    validator: (val: string) => ['lazy', 'eager'].includes(val),
  },
  crossorigin: {
    type: [Boolean, String],
    required: false,
    validator: (val: string) => ['anonymous', 'use-credentials', '', true, false].includes(val),
  },
  decoding: {
    type: String,
    required: false,
    validator: (val: string) => ['async', 'auto', 'sync'].includes(val),
  },
  // csp
  nonce: { type: [String], required: false },
  style: { type: [String, Object], required: false },
};
export const imgProps = {
  ...baseImageProps,
  placeholder: { type: [Boolean, String, Number, Array], required: false },
  placeholderClass: { type: String, required: false },
};
/** 与 `<NuxtImgWrap>` 一致的 props 类型 */
export type NuxtImgWrapProps = ExtractPropTypes<typeof imgProps>;
